const config = {
  "title": process.env.VUE_APP_TITLE,
  "description": ""
}

export default config;
